/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consult_Purchase_BtnInputs */

const en_consult_purchase_btn = /** @type {(inputs: Consult_Purchase_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send request`)
};

const id_consult_purchase_btn = /** @type {(inputs: Consult_Purchase_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim permintaan`)
};

/**
* | output |
* | --- |
* | "Send request" |
*
* @param {Consult_Purchase_BtnInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const consult_purchase_btn = /** @type {((inputs?: Consult_Purchase_BtnInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consult_Purchase_BtnInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_consult_purchase_btn(inputs)
	return en_consult_purchase_btn(inputs)
});